import React from "react";
import { Col, Row, Card, ListGroup, Button } from "react-bootstrap";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ListaPedido = ({
  items,
  total,
  handleRemove,
  cols,
  puntos,
  equivalenciapuntos,
  iva,
  puntosGenerados,
}) => {
  return (
    <Col xs={cols} md={cols} lg={cols} xl={cols}>
      <Card style={{}}>
        <Card.Header>Orden</Card.Header>
        <ListGroup variant="flush">
          {items.map((item, index) => (
            <ListGroup.Item key={index}>
              <Row>
                <Col xs={12}>
                  <div>
                    <strong>{item.name}</strong>
                  </div>
                </Col>
                <Col xs={10} className="left">
                  <Col md={12}>
                    <span className="margen-tam">
                      <strong>Tipo:</strong> {item.ncosto}
                    </span>
                    <span className="margen-tam">
                      <strong>Costo:</strong> ${item.costo}
                    </span>
                    <span>
                      <strong>Cantidad:</strong> {item.cantidad}{" "}
                    </span>
                  </Col>
                </Col>
                <Col xs={2} className="left">
                  <Button className="danger" onClick={() => handleRemove(item)}>
                    {" "}
                    <FontAwesomeIcon icon={faTrash} />
                  </Button>
                </Col>
                {item.recoger && (
                  <Col md={12}>
                    <span className="margen-tam">
                      <strong>Recoger el:</strong>
                      {" " +
                        item.recoger.toLocaleString("es-ES", {
                          weekday: "long",
                          hour: "numeric",
                          minute: "numeric",
                          hour12: true,
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })}
                    </span>
                  </Col>
                )}
                <Col xs={12}>
                  <strong>Ingredientes:</strong>
                  {Object.keys(item.ingredientes).map((obj, i) => {
                    return (
                      <Row style={{ paddingLeft: "30px" }}>
                        <strong>{item.ingredientes[obj].name}</strong>
                        <label style={{ marginBottom: 0 }}>
                          {item.ingredientes[obj].costo
                            ? "Costo: $" +
                              item.ingredientes[obj].costo.toFixed(2) +
                              "\n"
                            : ""}{" "}
                          Cantidad: {item.ingredientes[obj].cantidad}
                        </label>
                      </Row>
                    );
                  })}
                </Col>
                <Col xs={12}>
                  <strong>Añadidos:</strong>
                  {Object.keys(item.anadidos).map((obj, i) => {
                    return (
                      <Row style={{ paddingLeft: "30px" }}>
                        <strong>{item.anadidos[obj].name}</strong>
                        <label style={{ marginBottom: 0 }}>
                          {" "}
                          Costo:{" "}
                          {parseFloat(item.anadidos[obj].precio) > 0
                            ? "$" + item.anadidos[obj].precio
                            : "Gratis"}{" "}
                          Cantidad: {item.anadidos[obj].cantidad}
                        </label>
                      </Row>
                    );
                  })}
                </Col>
                <Col xs={12}>
                  <div>
                    <strong>Nota:</strong> {item.note}
                  </div>
                </Col>
              </Row>
            </ListGroup.Item>
          ))}
        </ListGroup>
        <Card.Footer>
          <Row>
            <Col md={6}>
              <span>SUBTOTAL:</span>
              <br />
              <span>IVA{" (" + iva + "%)"}:</span>
              <br />
              <span>PUNTOS:</span>
              <br />
              <span>TOTAL:</span>
              <br />
              <br />
              <span>PUNTOS GENERADOS:</span>
            </Col>
            <Col md={6}>
              <span>$ {(total / (1 + iva / 100)).toFixed(2)}</span>
              <br />
              <span>$ {(total - total / (1 + iva / 100)).toFixed(2)}</span>
              <br />
              <span> {puntos}</span>
              <br />
              <span>$ {(total - puntos * equivalenciapuntos).toFixed(2)}</span>
              <br />
              <br />
              <span>{" " + puntosGenerados}</span>
            </Col>
          </Row>
          <Row></Row>
        </Card.Footer>
      </Card>
    </Col>
  );
};

export default ListaPedido;
